import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../../Core/Container';
import Link from '../../../../Core/Link';
import Image from '../../../../Core/Image';
import { Info } from '../../styles';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.neutral_1')};
`;

export const StyledContainer = styled(Container)`
  padding: 50px 0px 20px;
  position: relative;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 85px 0 60px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 85px 90px 60px;
  }
`;

export const ImageContainer = styled(Container)`
  @media only screen and (max-width: calc(${themeGet(
    'breakpoints.md',
  )} - 1px)) {
    && {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

export const Title = styled.h1`
  margin-bottom: 5px;

  font-size: 30px;
  font-weight: ${themeGet('font-weights.bold')};
  letter-spacing: -0.2px;
  line-height: 34px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 56px;
    letter-spacing: -0.37px;
    line-height: 60px;
  }
`;

export const StyledInfo = styled(Info)`
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 28px;
  }
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;

  font-size: 18px;
  font-weight: ${themeGet('font-weights.bold')};
  letter-spacing: -0.35px;
  line-height: 38px;

  border-bottom: 0;
  padding: 0;

  &:hover,
  &:focus {
    border-bottom: 0;
    padding: 0;
  }

  &::before {
    content: '';
    height: 24px;
    width: 24px;
    background-image: url(${({ img }) => img});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    margin-right: 10px;
  }
`;

export const BannerImage = styled(Image)`
  max-height: 464px;
  width: 100%;
  object-fit: cover;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-height: 420px;
  }
`;
